import UploadShedule from "../components/UploadShedule";
export function AdminChangeSchedule() {
    document.title = `Промени график`;

    return (
        <main id="main" className="main">

            <div className="pagetitle">
                <h1 className="use-font">Промяна на график</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/schadm">Начало</a></li>
                        <li className="breadcrumb-item active">Промяна на график</li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard">

                <div className="row">

                    <div className="col-lg-12">
                        <div className="row">
                            <UploadShedule />
                        </div>
                    </div>

                </div>

            </section>

        </main>
    )
}

export default AdminChangeSchedule;